import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=f06b5d88&scoped=true&"
import script from "./validate.vue?vue&type=script&lang=js&"
export * from "./validate.vue?vue&type=script&lang=js&"
import style0 from "./validate.vue?vue&type=style&index=0&id=f06b5d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06b5d88",
  null
  
)

export default component.exports